module.exports = __webpack_public_path__ + "img/5.c9e5f3c3.jpg";